import { FormattedMessage } from "react-intl";
import { Label } from "../styles";

export default function StepLabel({ number, text, error }) {
  return (
    <Label error={error}>
      {`${number}. `}
      <FormattedMessage id={text} />
    </Label>
  );
}